import React from "react";
import { useNavigate, Link } from "react-router-dom";
import { Result, Button } from "antd";
import { SmileOutlined } from "@ant-design/icons";
export default function Home() {
  const navigate = useNavigate();
  return (
    <div className="homebanner">
      <div className="banner-main">
        <h2 style={{ top: "35%" }}>Big Apple Stars Awards Nomination</h2>
        <Result
          icon={<SmileOutlined />}
          // title="Great, we have done all the operations!"
          extra={
            <Button type="primary">
              <Link to="/member/nominations">Start</Link>
            </Button>
          }
        />
      </div>
    </div>
  );
}
